// Campus photo for /colleges/university-of-california-san-diego: CC BY-SA 2.0, by belisario on Flickr, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGeisel_Library%2C_UCSD.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-san-diego/; credited under the photo.
const photo = {
    "slug": "university-of-california-san-diego",
    "alt": "Geisel Library on the UC San Diego campus in La Jolla, California",
    "src": "/colleges/university-of-california-san-diego/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-san-diego/campus-800.webp",
    "srcMid": "/colleges/university-of-california-san-diego/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-san-diego/og.jpg",
    "title": "Geisel Library, UCSD",
    "author": "belisario on Flickr",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGeisel_Library%2C_UCSD.jpg",
    "read": "2026-09-30"
};

export default photo;
